(function() {
    'use strict';

    angular.module('vhols')
        .directive('cmcCookieSetter', ['$window', 'ipCookie', 'cookieExpiryService', function ($window, ipCookie, cookieExpiryService) {
            return {
                scope: {
                    expirationTime: "=",
                    origin: "="
                },
                restrict: 'AE',
                link: function ($scope, $element) {
                    $element.on('click', function () {
                        ipCookie("cmc_acknowledged", true, {"expires": cookieExpiryService.compute($scope.expirationTime),"path":"/"});
                        $window.location.replace($scope.origin);
                    });
                }
            };
        }]);
})();
